import { render, staticRenderFns } from "./employeesPageView.vue?vue&type=template&id=a87cb25e&scoped=true"
import script from "./employeesPageView.vue?vue&type=script&lang=js"
export * from "./employeesPageView.vue?vue&type=script&lang=js"
import style0 from "./employeesPageView.vue?vue&type=style&index=0&id=a87cb25e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87cb25e",
  null
  
)

export default component.exports